module.exports = "/_next/static/images/f31e89b750d85443a014379e2868dca8-card.jpg";